import Vue from 'vue';
import Vuex from 'vuex';

import rfq from '@/store/modules/rfq';
import axios from 'axios';
import renewal from '@/store/modules/renewal';
import auth from './modules/auth';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    client: [],
    clientLoading: true,
    notification: {},
    policy: '',
  },
  getters: {
    clientData: (state) => (state.client.length === 0 ? null : state.client[0]),
    notificationCount: (state) => ('MOTOR' in state.notification ? state.notification.MOTOR : 0) || 0,
  },
  mutations: {
    setClient(state, payload) {
      state.clientLoading = false;
      state.client = payload;
    },
    updateNotification(state, payload) {
      state.notification = payload;
    },
    updatePolicy(state, payload) {
      state.policy = payload;
    },
  },
  actions: {
    // getNotificationCount: async (context) => {
    //   await axios.get(`/customer/notification/app/unread/count/${context.state.auth.user.email}?pin=${context.state.auth.user['custom:kra-pin']}`).then((response) => {
    //     context.commit('updateNotification', response.data.data);
    //   });
    // },
    getPolicy: async (context, param) => {
      await axios.get(`/customer/gis/policies/details?policyNo=${param}`)
        .then((response) => {
          context.commit('updatePolicy', response.data.object);
        });
    },
  },
  modules: {
    auth,
    rfq,
    renewal,
  },
  strict: process.env.NODE_ENV !== 'production',
});

export default store;
